import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, Inject, Injector, Input, OnDestroy, Output } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { IKartComponent } from './IKart/ikart-kutusu.component';
import { IUyarKartComponent } from './IUyarDokum/uyar-kutusu.component';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';
import { IKart, IKartTuru, TurGizlilik, TurGizlilikBilgi } from '@/src/service/fikoyt-ui/interfaces/IKart.interface';
import { IParametreSetiGrubu } from '@/src/service/fikoyt-ui/interfaces/IParametreSeti.interface';
import { ServisUyarProjeler } from '@/src/app/uygulamalar/uyar-dokum/projeler/projeler.service';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzWaveModule } from 'ng-zorro-antd/core/wave';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzInputModule } from 'ng-zorro-antd/input';



@Component({
  selector: 'fikoyt-paylas-kutusu',
  templateUrl: './paylas-kutusu.component.html',
  styleUrls: ['./paylas-kutusu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    FormsModule,
    NzPopconfirmModule,
    NzWaveModule,
    NzButtonModule,
    NzInputModule,
    IKartComponent,
    IUyarKartComponent,
  ]
})
export class PaylasKutusuComponent extends FikoYTKokBilesenComponent implements OnDestroy {
  @Input() kart: IKart | undefined;
  @Input() parametreSetleri: IParametreSetiGrubu[] = [];
  @Input() parametreSetiZorunlu = false;
  @Input() taslakDevreDisi = false;
  /** */
  simgeButonGizlilik: string = "fa fa-globe-europe";
  /** */
  @Output() paylasimYapildi: EventEmitter<any> = new EventEmitter<any>();

  constructor(public servisUyarProjeler: ServisUyarProjeler) {
    super();
  }
}
